import MobileOnlyComponent from './MobileOnlyComponent';
export default MobileOnlyComponent;
